import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleOnetapLoginComponent } from './google-onetap-login.component';
import { MatDialogModule } from '@angular/material/dialog';



@NgModule({
  declarations: [
    GoogleOnetapLoginComponent
  ],
  exports: [
    GoogleOnetapLoginComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule
  ]
})
export class GoogleOnetapLoginModule { }
